import React from 'react';

import * as styles from './LeaderboardSlide.module.scss';

export const LeaderboardSlide = (): React.ReactElement => {
  return (
    <div className={styles.container}>
      <div className={styles.retailSecondImage} />
      <h1 className={`${styles['header-leader-retail']} mt-4 mb-2`}>Leaderboard reveals opportunity</h1>
      <p className={styles['subheader-retail']}>
        {`Essential metrics on your market performance versus your`}
        <br />
        {`competitors' shows you the whole picture.`}
      </p>
      <p className="text-sm text-inactive mt-2">gfknewron for Retail</p>
    </div>
  );
};
